import React from 'react';
import { useSelector } from 'react-redux';
import { KeyboardArrowDown } from '@mui/icons-material';
// import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Select, MenuItem, Typography } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';
import { useTranslation } from 'react-i18next';

const PrivacyDropdown = ({ selectedOption, setSelectedOption, setInfo }) => {
  const policyTemplateTypes = useSelector(state => state.privacy.policyTemplateTypes);
  const { t } = useTranslation('translation', { keyPrefix: 'policy_manager' });

  const handleChange = event => {
    setSelectedOption(event.target.value);
  };

  return (
    <>
      <Select
        type='select'
        value={selectedOption}
        onChange={handleChange}
        displayEmpty
        IconComponent={KeyboardArrowDown}
        id='step-5'
        inputProps={{
          'aria-label': 'Language Selector',
          MenuProps: {
            PaperProps: {
              sx: {
                backgroundColor: ColorsV2.secondary,
                color: ColorsV2.white,
                border: '1px solid transparent',
                borderColor: ColorsV2.outline,
              },
            },
          },
        }}
        sx={{
          ...Buttons.baseStyle.primaryButtonLowPriority,
          '&.MuiOutlinedInput-root.Mui-focused': {
            border: 'solid 2px ' + ColorsV2.acent,
          },
          '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
      >
        <MenuItem value='default' disabled>
          <Typography variant='body1'>
            {t('empty_selection')}
          </Typography>
        </MenuItem>
        {policyTemplateTypes?.templates?.map(items => (
          <MenuItem
            value={items?.id}
            key={items?.id}
            onClick={() => setInfo({ name: items?.name, description: items.description })}
          >
            <Typography variant='body1'>
              {items?.name}
            </Typography>
          </MenuItem>
        ))}
      </Select>

      {/* <Tour /> */}
    </>
  );
};

export default PrivacyDropdown;
